module.exports = __webpack_public_path__ + "img/logo.1f785b01.svg";